import authLayoutStyles from "layouts/AuthLayout/AuthLayout.styles";
import { Box, Container, Stack, Typography } from "@mui/material";
import title from "global/constants/TitleConstants";

interface CustomProps {
  children: any;
}

const AuthLayout = (props: CustomProps) => {
  const classes = authLayoutStyles;

  return (
    <Box sx={classes.root}>
      <Box sx={classes.rootBox}>
        <Container
          maxWidth={false}
          sx={{ ...classes.container, maxWidth: "700px" }}
        >
          {props.children}
        </Container>
        <Stack mt={1} alignItems="center">
          <Typography variant="body2" color="text.primary">{`© ${new Date().getFullYear()} ${
            title.App
          }. All Rights Reserved.`}</Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default AuthLayout;
